
const ControlledDocReducer = (state = {}, action) => {
    switch (action.type) {
        case "getCDocFolderListSuccess":
            return Object.assign({}, state, {
                CDocFolderList: action.data,
            });
            break;
        case "getCDocFileListSuccess":
            return Object.assign({}, state, {
                CDocFolderfiles: action.data,
            });
            break;
            
        case "postCDocAttachmentUploadSuccess":
            return Object.assign({}, state, {
                CDocAttachment: action.data,
            });
            break;
        case "docSearch":
            return Object.assign({}, state, {
                docSearch: action.data,
            });
            break;
        default: {
            return state;
        }
    }
}
export default ControlledDocReducer;